module.exports = __webpack_public_path__ + "static/hero-about-us-2e792ec0b78af15401d119dcef799df4.webp";